'use client';

import { skipToken, useQuery } from '@tanstack/react-query';

export type CurrentUser = {
  id: string;
  name: string;
  initials: string;
  color: string;
  imageUrl?: string;
  email?: string;
  accountName?: string;
};

// Cache-only: /partner has no identity of its own, so the user is resolved by
// /partner/proxy and seeded into ['currentUser'] by PartnerPageClient on
// FB_PROXY_INIT. Never fetches.
export function useCurrentUser() {
  return useQuery<CurrentUser>({
    queryKey: ['currentUser'],
    queryFn: skipToken,
    staleTime: Infinity,
  });
}
